import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Features.css';

const Features = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      icon: '🏠',
      title: 'Renter Equity Building',
      description: 'Automatically invest 5% of your rent into your building\'s equity. Watch your wealth grow every month while you live there.'
    },
    {
      icon: '📱',
      title: 'Mobile Real Estate Market',
      description: 'Buy and sell property shares like stocks. Discover properties, analyze returns, and build a diversified portfolio from your phone.'
    },
    {
      icon: '💰',
      title: 'Rent Pool & Automation',
      description: 'Deposit up to 12 months of rent in advance. Perfect for freelancers and gig workers. We pay your landlord on time, every time, while you earn interest on deposits.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="features" className="features" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="migra-font">Real Estate Investing Made Simple</h2>
          <p>We've created the first mobile platform that lets renters build equity while living in their homes, plus allows anyone to invest in real estate with just a few taps.</p>
        </motion.div>
        
        <motion.div 
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              variants={itemVariants}
              transition={{ duration: 0.6 }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;